type Require = __WebpackModuleApi.RequireContext;
const atlasesContext: Require = require.context('../../../static/atlases', true, /\.json$/);
const imagesContext: Require = require.context('../../../static/images', true);
const fontsContext: Require = require.context('../../../static/fonts', true);
const audioContext: Require = require.context('../../../static/audio', true);

export function addAssetsToLoader(loader: Phaser.Loader): void {
  atlasesContext.keys().forEach((key: string) => {
    const name = keyToName(key);
    loader.atlasJSONHash(name, `atlases/${name}.png`, `atlases/${name}.json`);
  });

  imagesContext.keys().forEach((key: string) => {
    loader.image(keyToName(key), `images/${key.slice(2)}`);
  });

  fontsContext.keys().forEach((key: string) => {
    const name: string = keyToName(key);
    const url: string = `fonts/${key.slice(2)}`;
    addFontFace(name, url);
  });

  audioContext.keys().forEach((key: string) => {
    loader.audio(keyToName(key), `audio/${key.slice(2)}`);
  });
}

function keyToName(key: string): string {
  return (key.split('/').pop() as string).split('.').shift() as string;
}

function addFontFace(name: string, url: string): void {
  const element: HTMLElement = document.getElementById('fonts') || createFontsElement();
  element.innerHTML += `@font-face {
font-family: '${name}';
src: url('${url}');
};`;

  const div: HTMLElement = document.createElement('div');
  div.innerText = '1';
  div.style.fontFamily = name;
  div.style.position = 'absolute';
  div.style.top = '-999px';
  document.body.appendChild(div);
}

function createFontsElement(): HTMLElement {
  const style: HTMLElement = document.createElement('style');
  style.id = 'fonts';
  document.body.appendChild(style);
  return style;
}